import React, {
    Fragment,
    useCallback,
    useState,
    useEffect,
    useRef,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FacetedSearchCompact from './FacetedSearchCompact';
import { AccordionPanel, Accordion } from '../Components/Accordion';
import { query } from '../Actions/FacetedSearch.action';
import SubNav from './SubNavCompact';
import SortCriteriaCompact from './SortCriteriaCompact';
import FilterTag from './FilterTags';
import { translate } from '../Services/translation';
import { updateFilterOption } from '../Actions/FacetedSearch.action';
import { PRODUCT_VIEW_CACHED } from '../constants';

const FacetedSearchCompactContainer = () => {
    const dispatch = useDispatch();
    const {
        subNavigation,
        sortCriteria,
        facetFilters: globalFacetFilters,
        navigationTheme,
        productsViewCachedId,
    } = useSelector((state) => state.facetedSearch);

    const [facetFilters, setFacetFilters] = useState(globalFacetFilters || []);
    const previousCachedId = useRef(productsViewCachedId);
    useEffect(() => {
        if (previousCachedId.current !== productsViewCachedId) {
            setFacetFilters(globalFacetFilters);
            previousCachedId.current = productsViewCachedId;
        }
    }, [globalFacetFilters, productsViewCachedId]);

    useEffect(() => {
        dispatch(query(window.location.search.substr(1) || '', false));
    }, [dispatch]);

    const onFacetChange = useCallback(
        (filter, option) => {
            setFacetFilters((prevFacetFilters) => {
                return updateFilterOption(prevFacetFilters, filter, option);
            });
        },
        [setFacetFilters]
    );

    const onSearchResultDataChange = (dom) => {
        if ([null, undefined].includes(dom)) {
            return;
        }
        const container = document.createElement('div');
        container.innerHTML = dom;
        const existingResult = document.querySelector('#search-result');
        const tempResult = container.querySelector('#search-result');
        const existingFilter = existingResult.querySelector(
            '#facetedSearchCompact'
        );
        const tempFilter = tempResult.querySelector('#facetedSearchCompact');
        const replace = (node, newNode) =>
            node.parentNode.replaceChild(newNode, node);
        // move existingFilter from existingResult to tempResult
        replace(tempFilter, existingFilter);
        // replace existingResult with tempResult ( newResult )
        replace(existingResult, tempResult);
        // bootstrap react components if any exists in the search result
        window.__litium.bootstrapComponents();
    };

    useEffect(() => {
        window.addEventListener("resize", () => {
            if (window.innerWidth < 769) {
                return
            }

            const el = document.querySelector(".filter-mobile .filter-list")
            if (!el) return

            el.classList.remove("show")
        })
        const productViewCached = window.__litium.cache
            ? window.__litium.cache[PRODUCT_VIEW_CACHED] || {}
            : {};
        if (!productViewCached.used) {
            productViewCached.used = true;
            const dom = productViewCached.productsView;
            dom && onSearchResultDataChange(dom);
        }
    });

    const empty = (array) => !(array && array.length);

    const subNavigations = !subNavigation ? null : [subNavigation];
    const sortCriterias =
        !sortCriteria || !sortCriteria.sortItems
            ? null
            : sortCriteria.sortItems;

    const hidden = [subNavigations, facetFilters, sortCriterias].every((arr) =>
        empty(arr)
    );

    const toggleFilters = () => {
        console.log('hej')
        const el = document.querySelector(".filter-mobile .filter-list")
        if (!el) return

        el.classList.toggle("show")
    }

    return hidden ? null : (
        <Fragment>
            {/*<FilterTag*/}
            {/*    {...{*/}
            {/*        facetFilters: globalFacetFilters,*/}
            {/*        navigationTheme: navigationTheme || '',*/}
            {/*    }}*/}
            {/*/>*/}
            <button className="filter-toggle" onClick={toggleFilters} >
                <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.4999 7.80586C7.8999 7.80586 9.0999 8.70587 9.3999 10.1059H14.6999C15.0999 10.1059 15.4999 10.4059 15.4999 10.9059C15.4999 11.4059 15.1999 11.7059 14.6999 11.7059H9.3999C8.9999 13.3059 7.2999 14.3059 5.6999 13.9059C4.5999 13.6059 3.7999 12.8059 3.4999 11.7059H1.1999C0.799898 11.7059 0.399902 11.4059 0.399902 10.9059C0.399902 10.4059 0.699898 10.1059 1.1999 10.1059H3.4999C3.8999 8.70587 5.0999 7.80586 6.4999 7.80586ZM6.4999 9.30586C5.6999 9.30586 4.9999 10.0059 4.9999 10.8059V10.9059C5.0999 11.7059 5.7999 12.3059 6.5999 12.2059C7.3999 12.1059 7.9999 11.4059 7.8999 10.6059C7.8999 9.80587 7.2999 9.20586 6.4999 9.30586ZM12.9999 0.00585938C14.6999 0.00585938 15.9999 1.30586 15.9999 3.00586C15.9999 4.70586 14.6999 6.00586 12.9999 6.00586C11.6999 6.00586 10.5999 5.20586 10.1999 4.00586H1.2999C0.899904 4.00586 0.499901 3.70586 0.499901 3.20586C0.499901 2.70586 0.799904 2.40585 1.2999 2.40585H10.0999C10.2999 1.10585 11.4999 0.00585938 12.9999 0.00585938ZM12.9999 1.50586C12.1999 1.50586 11.4999 2.20586 11.4999 3.00586C11.4999 3.80586 12.1999 4.50586 12.9999 4.50586C13.7999 4.50586 14.4999 3.80586 14.4999 3.00586C14.4999 2.20586 13.7999 1.50586 12.9999 1.50586Z" fill="#212121" />
                </svg>
                <h4>Filter</h4>
            </button>

            {!empty(facetFilters) && (
                    <FacetedSearchCompact
                        {...{
                            facetFilters,
                            onFacetChange,
                        }}
                    />
            )}
            {!empty(sortCriterias) && (
                    <SortCriteriaCompact
                        {...{ sortCriteria: sortCriterias }}
                    />
            )}
            {!empty(facetFilters) && (
                <div className="filter-mobile">
                    <FacetedSearchCompact
                        {...{
                            facetFilters,
                            onFacetChange,
                        }}
                    />
                </div>
            )}
            {navigationTheme === 'category' && (
                <div className="compact-filter category-theme show-for-large">
                    <FacetedSearchCompact
                        {...{
                            facetFilters,
                            onFacetChange,
                        }}
                    />
                </div>
            )}
        </Fragment>
    );
};

export default FacetedSearchCompactContainer;
